export default {
  copyright: '© Les Filles et les Sciences - Un Duo Électrisant [YEAR]',
  credits: 'Site conçu et développé par <em>Beet</em>',
}
